import { FileApiService } from '../../../../data-transfer/services/file-api-service';
import { AuthService } from './../../../../services/auth-service';
import { MaterialApiService } from '../../../../data-transfer/services/material-api-service';
import { ComponentCanDeactivate } from './../../../../services/unsaved-changes-guard';
import { ActivatedRoute, Router } from '@angular/router';
import { MultiMaterialCompositeDto } from '../../../../data-transfer/entities/material-entities/multi-material-composite-dto';
import { FormGroup, FormBuilder } from '@angular/forms';
import { CreateUpdateHandler } from './../../../../services/packaging-services/create-update-handler';
import { Component, OnInit, HostListener, ViewChild, ChangeDetectorRef, inject } from '@angular/core';
import { tap } from 'rxjs/operators';
import { MaterialNavigationService } from 'src/app/navigation/services/navigation-services/material-navigation.service';
import { MatDialog } from '@angular/material/dialog';
import { CreateUpdatePackagingPartComponent } from 'src/app/components/shared-components/parent-components/create-update-packaging-part/create-update-packaging-part.component';
import { ColorThemeService } from 'src/app/navigation/services/color-theme-service';
import { VersionDto } from 'src/app/data-transfer/entities/version-dto';
import { PackagingComponentTypesEnum } from 'src/app/model/packaging-component-types-enum';
import { MaterialFunctionDto } from 'src/app/data-transfer/entities/material-function-dto';
import { MultiMaterialTableComponent } from 'src/app/components/shared-components/multi-material-table/multi-material-table.component';
import { CompositeMaterialSevice } from 'src/app/services/material-services/composite-material-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CoreDataUpdateService } from 'src/app/data-transfer/services/core-data-update-api-service';
import { DataExchangeRequestApiService } from 'src/app/data-transfer/services/data-exchange-request-api-service';
import { PathResolveService } from 'src/app/services/path-resolve.service';
import { SimpleAlertDialogComponent } from 'src/app/components/dialogs/simple-alert-dialog/simple-alert-dialog.component';
import { getDialogConfig } from 'src/app/util/dialog-util';
import { showApiErrorDialog } from 'src/app/util/api-error-util';
import { AffectedPackagingConfirmation, confirmAffectedPackaging } from 'src/app/util/affected-packaging-util';
import { PpwrDocumentHandlingModeDto } from 'src/app/data-transfer/entities/ppwr-entities/ppwr-document-handling-mode-dto';
import { DirectoryApiService } from 'src/app/data-transfer/services/directory-api-service';
import { TranslocoService } from '@jsverse/transloco';
import { openCreateDataExchangeRequestDialog } from 'src/app/util/data-exchange-request-util';
import { DataExchangeRequestDto } from 'src/app/data-transfer/entities/data-exchange-request-entities/data-exchange-request-dto';
import { DataExchangeRequestStatusDto } from 'src/app/data-transfer/entities/data-exchange-request-entities/data-exchange-request-status-dto';
import { UpdateDataExchangeRequestStatusDto } from 'src/app/data-transfer/entities/data-exchange-request-entities/update-data-exchange-request-status-dto';
import {
  SubRequestCommentsDialogComponent,
  SubRequestCommentsDialogData,
  SubRequestCommentsDialogResult,
} from 'src/app/components/dialogs/sub-request-comments-dialog/sub-request-comments-dialog.component';
import { PackagingPart } from 'src/app/model/packaging-part-enum';
import { PackagingPartExportService } from 'src/app/services/packaging-services/packaging-part-export.service';
@Component({
  selector: 'app-composite-material',
  templateUrl: './composite-material.component.html',
  styleUrls: ['./composite-material.component.scss'],
})
export class CompositeMaterialComponent extends CreateUpdatePackagingPartComponent implements OnInit, ComponentCanDeactivate {
  @ViewChild(MultiMaterialTableComponent) private materialsTable!: MultiMaterialTableComponent;

  materialForm!: FormGroup;
  compositeMaterial!: MultiMaterialCompositeDto;

  callerId: number;
  packagingUnitTypeId: number;
  allMaterialFunctions: MaterialFunctionDto[] = [];
  selectedManufacturingCountry = '';
  maxCommentLength = 250;
  materialLayersUpdated = false;
  isInternallyTracked: boolean = false;
  isDataExchangeSubRequest = false;
  isInOngoingDataExchange: DataExchangeRequestDto[] = [];
  readonly dataExchangeRequestsPath = '/' + PathResolveService.getDataExchangeRequestsPath(true);
  readonly DataExchangeRequestStatusDto = DataExchangeRequestStatusDto;

  private readonly exportService = inject(PackagingPartExportService);

  constructor(
    protected handler: CreateUpdateHandler,
    protected dialog: MatDialog,
    protected authService: AuthService,
    protected colorThemeService: ColorThemeService,
    protected cdr: ChangeDetectorRef,
    protected route: ActivatedRoute,
    protected spinner: NgxSpinnerService,
    protected fileApiService: FileApiService,
    protected coreDataUpdateService: CoreDataUpdateService,
    private formBuilder: FormBuilder,
    private materialApiService: MaterialApiService,
    private navigationService: MaterialNavigationService,
    private router: Router,
    private dataExchangeApiService: DataExchangeRequestApiService,
    private directoryApiService: DirectoryApiService,
    private translocoService: TranslocoService
  ) {
    super(handler, dialog, colorThemeService, authService, cdr, route, spinner, fileApiService, coreDataUpdateService);
    this.callerId = PackagingComponentTypesEnum.MainBody;
    this.packagingUnitTypeId = 1;
    this.allMaterialFunctions = this.handler.getMaterialFunctions(this.packagingUnitTypeId, this.callerId);
  }

  protected getReleaseUrl(materialId: number): string {
    return this.materialApiService.getReleaseUrl(materialId);
  }

  private lockCompositeMaterial =(materialId: number) => this.materialApiService.lockCompositeMaterial(materialId, true);

  ngOnInit(): void {
    this.routeParamsSubscription = this.route.params.subscribe(params => {
      if (params.candidateId) {
        this.isPreview = true;
      }
    });
    this.routeDataSubscription = this.route.data.subscribe(data => {
      if (data.compositeMaterial) {
        this.compositeMaterial = data.compositeMaterial;
        this.relevantAnalysisTypes.ccRelevant = data.compositeMaterial.isCCRelevant;
        this.relevantAnalysisTypes.lcaRelevant = data.compositeMaterial.isLCARelevant;
        this.relevantAnalysisTypes.ppwrRelevant = data.compositeMaterial.isPPWRRelevant;
        this.relevantAnalysisTypes.recyclingRelevant = data.compositeMaterial.isRecyclabilityRelevant;
        this.currentDirectoryId = data.compositeMaterial.directoryId;
        this.isTracked = this.compositeMaterial?.hasExternalTracking ?? false;
        this.isHistory = this.compositeMaterial?.id != null && !this.compositeMaterial.isCurrentVersion;
        if (this.materialForm) {
          window.location.reload();
        }
        this.selectedTags = this.allTags.filter(tag => this.compositeMaterial.associatedTagIdentifiers.includes(tag.id ?? -1) ?? false);
      } else if (data.dataExchangeRequest) {
        this.compositeMaterial = data.dataExchangeRequest.multiMaterial;
        this.subRequestInfo = data.dataExchangeRequest.subRequestInfo;
        this.relevantAnalysisTypes.ccRelevant = data.dataExchangeRequest.multiMaterial.isCCRelevant;
        this.relevantAnalysisTypes.lcaRelevant = data.dataExchangeRequest.multiMaterial.isLCARelevant;
        this.relevantAnalysisTypes.ppwrRelevant = data.dataExchangeRequest.multiMaterial.isPPWRRelevant;
        this.relevantAnalysisTypes.recyclingRelevant = data.dataExchangeRequest.multiMaterial.isRecyclabilityRelevant;
        this.currentDirectoryId = data.dataExchangeRequest.multiMaterial.directoryId;
        this.isTracked = this.compositeMaterial?.hasExternalTracking ?? false;
        this.isHistory = this.compositeMaterial?.id != null && !this.compositeMaterial.isCurrentVersion;
        if (this.materialForm) {
          window.location.reload();
        }
        this.selectedTags = this.allTags.filter(tag => this.compositeMaterial.associatedTagIdentifiers.includes(tag.id ?? -1) ?? false);
      } else {
        this.compositeMaterial = CompositeMaterialSevice.createEmptyCompositeMaterial();
      }
      if (data.permissions) {
        this.permissions = data.permissions;
        this.isEditPermitted = this.permissions?.write ?? true;
      }

      this.isInternallyTracked = data.dataExchangeRequest?.isInternallyTracked ?? data.isInternallyTracked;
      if (data.isDataExchangeSubRequest) {
        this.isDataExchangeSubRequest = true;
        if (!data.permissions) {
          this.permissionsPending = true;
          this.materialApiService.getMaterialPermissions(this.compositeMaterial.id ?? -1).subscribe({
            next: permissions => {
              this.permissionsPending = false;
              this.permissions = permissions;
              this.isEditPermitted = this.permissions?.write ?? true;
              this.disableFormIfRequired(this.materialForm);
              this.setUpLockAndHeartbeat(this.materialForm, this.lockCompositeMaterial, this.compositeMaterial.id);
            },
            error: () => {
              this.permissionsPending = false;
              this.isEditPermitted = false;
              this.disableFormIfRequired(this.materialForm);
            },
          });
        }
      }
      if (data.isInOngoingDataExchange) {
        this.isInOngoingDataExchange = data.isInOngoingDataExchange;
        if (this.isInOngoingDataExchange.length > 0 && this.compositeMaterial.isCurrentVersion) {
          const firstRequest = this.isInOngoingDataExchange[0];
          const subRequest = firstRequest.subRequests?.find(sr => sr.multiMaterial?.id === this.compositeMaterial.id);
          const path = subRequest ? '/' + PathResolveService.getDataExchangeRequestMaterialPath(true, subRequest.id) : this.dataExchangeRequestsPath;
          this.router.navigateByUrl(path);
          return;
        }
      }
    });
    this.materialForm = this.formBuilder.group({
      multiMaterialControl: [this.compositeMaterial],
      newVersionName: [''],
      comment: [this.compositeMaterial.comment],
      images: [this.compositeMaterial.images],
      certificates: [this.compositeMaterial.certificates],
      documents: [this.compositeMaterial.documents],
    });
    this.setUpLockAndHeartbeat(this.materialForm, this.lockCompositeMaterial, this.compositeMaterial?.id);
    this.disableFormIfRequired(this.materialForm);
    this.historyVersions = [
      {
        id: this.compositeMaterial.id,
        versionNumber: this.compositeMaterial.version,
        creationTimestamp: this.compositeMaterial.creationTimestamp,
        isCurrentVersion: this.compositeMaterial.isCurrentVersion,
      },
    ];
  }

  onManufacturingCountryChanged(countryCode: string) {
    this.selectedManufacturingCountry = countryCode;
  }

  @HostListener('window:beforeunload')
  canDeactivate(): boolean {
    return (this.materialForm?.pristine && !this.filesEdited) || this.isPreview || this.isUserValidator || this.isUserAdmin || this.isHistory;
  }

  async releaseComponent() {
    const releaseFunction = (materialId: number) => this.materialApiService.releaseCompositeMaterial(materialId, true);
    super.releaseComponent(this.compositeMaterial.id, releaseFunction);
  }

  loadHistoryVersions() {
    const versionsFunction = (materialId: number) => this.materialApiService.getCompositeMaterialHistoryVersions(materialId);
    super.loadHistoryVersions(this.compositeMaterial.id, versionsFunction);
  }

  onHistoryVersionChange(version: number) {
    const navigationFunction = (materialId: number, materialVersion?: number) => {
      if (materialVersion == null && this.isInOngoingDataExchange.length > 0) {
        const firstRequest = this.isInOngoingDataExchange[0];
        const subRequest = firstRequest.subRequests?.find(sr => sr.multiMaterial?.id === materialId);
        const path = subRequest ? '/' + PathResolveService.getDataExchangeRequestMaterialPath(true, subRequest.id) : this.dataExchangeRequestsPath;
        this.router.navigateByUrl(path);
      } else {
        this.navigationService.navigateToMaterial(materialId, materialVersion);
      }
    };
    super.onHistoryVersionChange(version, navigationFunction);
  }

  editVersionName(material: VersionDto) {
    const renameFunction = (id: number, version: number, name: string) => this.materialApiService.renameCompositeMaterial(id, version, name, true);
    super.editVersionName(material, this.compositeMaterial, renameFunction);
  }

  totalWeightChanged(newTotalWeight: number): void {
    const compositeMaterial = this.materialForm.controls.multiMaterialControl.value;
    compositeMaterial.totalWeight = newTotalWeight;
    this.materialForm.controls.multiMaterialControl.patchValue(compositeMaterial);
    this.compositeMaterial.totalWeight = newTotalWeight;
    this.materialLayersUpdated = true;
  }

  private isFormValid() {
    this.materialForm.markAllAsTouched();
    this.materialForm.updateValueAndValidity();
    return this.materialForm.valid;
  }

  private formToDto(): MultiMaterialCompositeDto {
    const formValue = this.materialForm.controls.multiMaterialControl.value;
    if (!this.materialForm || !formValue) {
      throw new Error('CompositeMaterialComponent: form is undefined');
    }
    const material = this.compositeMaterial;
    material.comment = this.materialForm.controls.comment.value;
    material.manufacturerName = formValue.manufacturerName;
    material.articleName = formValue.articleName;
    material.articleNumber = formValue.articleNumber;
    material.manufacturingCountry = formValue.manufacturingCountry;
    material.gtin = formValue.gtin;
    material.totalGrammage = formValue.totalGrammage;
    material.totalWeight = formValue.totalWeight;
    material.versionName = this.materialForm.value.newVersionName;
    return material;
  }

  getUpdatedMaterial(): MultiMaterialCompositeDto {
    return this.formToDto();
  }

  async onSubmit() {
    if (!this.isFormValid()) {
      super.openFormInvalidDialog();
    } else {
      const dirId = this.currentDirectoryId != null ? this.currentDirectoryId : await super.selectDirectory();
      if (dirId == null) {
        return;
      }
      this.saveCompositeMaterial(dirId);
    }
  }

  private isSavePermittedByAffectedPackaging(material: MultiMaterialCompositeDto): Promise<AffectedPackagingConfirmation> {
    return confirmAffectedPackaging(
      this.dialog,
      this.translocoService,
      this.compositeMaterial.id,
      (id, stayOnPage) => this.materialApiService.getAffectedPackaging(id, stayOnPage),
      !this.isDataExchangeSubRequest,
      stayOnPage => this.materialApiService.wouldCreateNewVersion(material, stayOnPage)
    );
  }

  onSubRequestCommentAdded(text: string): void {
    if (!this.subRequestInfo) {
      return;
    }
    const subRequestId = this.subRequestInfo.subRequest.id;
    this.dataExchangeApiService.addSubRequestComment(subRequestId, text, true).subscribe({
      error: error => showApiErrorDialog(this.dialog, error, this.translocoService),
      next: () => {
        this.dataExchangeApiService.getSubRequestInfo(subRequestId, true).subscribe({
          next: info => {
            this.subRequestInfo = info;
          },
        });
      },
    });
  }

  onApproveSubRequest(): void {
    if (!this.subRequestInfo) {
      return;
    }
    const dto: UpdateDataExchangeRequestStatusDto = { status: DataExchangeRequestStatusDto.Closed };
    this.dataExchangeApiService.updateSubRequestStatus(this.subRequestInfo.subRequest.id, dto, true).subscribe({
      error: error => showApiErrorDialog(this.dialog, error, this.translocoService),
      next: () => this.onSubRequestFinished()
    });
  }

  onReopenSubRequest(): void {
    if (!this.subRequestInfo) {
      return;
    }
    const title = this.translocoService.translate('dataManagement.dataExchangeRequests.comments.subRequestTitle');
    const data: SubRequestCommentsDialogData = {
      comments: this.subRequestInfo.subRequest.comments,
      title,
      allowOptionalComment: true,
      confirmButtonTranslationKey: 'dataManagement.dataExchangeRequests.buttons.reopenSubRequest',
    };
    const dialogRef = this.dialog.open(SubRequestCommentsDialogComponent, getDialogConfig(data, '500px'));
    dialogRef.afterClosed().subscribe((result: SubRequestCommentsDialogResult | undefined) => {
      if (!result?.confirmed) {
        return;
      }

      const dto: UpdateDataExchangeRequestStatusDto = { status: DataExchangeRequestStatusDto.ReOpened };
      this.dataExchangeApiService.updateSubRequestStatus(this.subRequestInfo!.subRequest.id, dto, true).subscribe({
        error: error => showApiErrorDialog(this.dialog, error, this.translocoService),
        next: () => {
          if (result.comment) {
            this.dataExchangeApiService.addSubRequestComment(this.subRequestInfo!.subRequest.id, result.comment, true).subscribe({
              error: error => showApiErrorDialog(this.dialog, error, this.translocoService),
              next: () => this.onSubRequestFinished()
            });
            return;
          }

          this.onSubRequestFinished();
        }
      });
    });
  }
  exportDataset(): void {
    if (this.compositeMaterial.id == null) {
      return;
    }

    const materialId = this.compositeMaterial.id;

    this.confirmProceedIfUnsaved(this.materialForm, () => this.exportService.exportPackagingParts(PackagingPart.Material, [materialId]));
  }

  onCreateDataExchangeRequestClicked(): void {
    this.confirmProceedIfUnsaved(this.materialForm, () => this.createDataExchangeRequest());
  }

  createDataExchangeRequest(): void {
    const materialId = this.compositeMaterial.id;
    if (materialId == null) {
      return;
    }

    openCreateDataExchangeRequestDialog(
      {
        dialog: this.dialog,
        directoryApiService: this.directoryApiService,
        dataExchangeApiService: this.dataExchangeApiService,
        translocoService: this.translocoService,
        destroyRef: this.destroyRef,
      },
      { materialIds: [materialId] },
      this.isCreatingDataExchangeRequest
    );
  }

  protected override navigateToSubRequest(): void {
    const path = PathResolveService.getDataExchangeRequestMaterialPath(true, this.route.snapshot.params['id']);
    this.router.navigateByUrl(path);
  }

  async onFinishRequest() {
    if (!this.isFormValid()) {
      super.openFormInvalidDialog();
      return;
    }
    const material = this.getUpdatedMaterial();
    await super.updateImagesAndDocuments(material);

    const confirmation = await this.isSavePermittedByAffectedPackaging(material);
    if (!confirmation.proceed) {
      return;
    }
    material.ppwrDocumentHandling = confirmation.handling ?? null;
    const recreateRequested = confirmation.handling?.mode === PpwrDocumentHandlingModeDto.Recreate;
    const subRequestId = +this.route.snapshot.params['id'];
    this.spinner.show();
    this.dataExchangeApiService.updateSubRequestMultiMaterial(subRequestId, material, true, true)
      .subscribe({
        next: _ => {
          this.spinner.hide();
          Object.keys(this.materialForm.controls).forEach(control => {
            this.materialForm.controls[control].markAsPristine();
          });
          this.materialForm.markAsPristine();
          this.filesEdited = false;
          this.onSubRequestFinished();
        },
        error: e => {
          this.spinner.hide();
          const dialogData = this.handler.getFailureDialogData(e, recreateRequested);
          this.dialog.open(SimpleAlertDialogComponent, getDialogConfig(dialogData, '400px'));
        }
      });
  }

  private async saveCompositeMaterial(directoryId: number) {
    const material = this.getUpdatedMaterial();
    material.directoryId = directoryId;
    await super.updateImagesAndDocuments(material);

    const confirmation = await this.isSavePermittedByAffectedPackaging(material);
    if (!confirmation.proceed) {
      return;
    }
    material.ppwrDocumentHandling = confirmation.handling ?? null;

    let saveFunction = (packagingItem: MultiMaterialCompositeDto, stayOnPage: boolean) => this.materialApiService.putCompositeMaterial(packagingItem, stayOnPage);

    let navFunction = (id: number, version: number) => this.navigationService.navigateToMaterial(id, version);

    if (this.isDataExchangeSubRequest) {
      const subRequestId = +this.route.snapshot.params['id'];
      saveFunction = (packagingItem: MultiMaterialCompositeDto, stayOnPage: boolean) =>
        this.dataExchangeApiService.updateSubRequestMultiMaterial(subRequestId, packagingItem, undefined, stayOnPage)
          .pipe(tap(() => this.dataExchangeSync.notifyUpdated(subRequestId)));
      navFunction = () => this.navigateToSubRequest();
    }

    super.putPackagingItem(material, this.materialForm, saveFunction, navFunction);
  }

  setTags() {
    this.compositeMaterial.associatedTagIdentifiers = this.selectedTags.map(tag => tag.id ?? -1);
  }
}
